import { ReactNode } from 'react';
import {
  TableHead as MUITableHead,
  TableHeadProps as MUITableHeadProps,
} from '@mui/material';

type AtomMUIProps = {
  children?: ReactNode;
};

export type TableHeadProps = AtomMUIProps;

const TableHead = (props: TableHeadProps) => {
  const MUIProps: MUITableHeadProps = props;

  return <MUITableHead {...MUIProps} />;
};

export default TableHead;
